import moment from 'moment'

import 'moment/locale/nl'
import 'moment/locale/fr'
import 'moment/locale/de'

moment.locale('nl')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
